export default {
  'sql.title.param': {
    ko: 'SQL 패러미터',
    ja: 'SQLパラメータ',
    en: 'SQL Parameters',
    cn: '',
  },
  'sql.title.sql.context': {
    ko: 'SQL 문맥',
    ja: 'SQLコンテキスト',
    en: 'SQL Context',
    cn: '',
  },
  'sql.cua.prog': {
    ko: 'Reference Program',
    ja: 'リファレンスプログラム',
    en: 'Reference Program',
    cn: '',
  },
  'sql.title.ctxt.menu': {
    ko: 'View SQL details',
    ja: 'View SQL details',
    en: 'View SQL details',
    cn: '',
  },
  'sql.title.dbreq': {
    ko: 'SAP > DB 호출 상세',
    ja: 'SAP>DBリクエスト',
    en: 'SAP > DB Requests',
    cn: '',
  },
  'sql.title.plan': {
    ko: '실행 계획',
    ja: '実行計画',
    en: 'Execution plan',
    cn: '',
  },
  'sql.param.seq': {
    ko: '번호',
    ja: '番号',
    en: 'No.',
    cn: '',
  },
  'sql.report': {
    ko: 'Report',
    ja: 'レポート',
    en: 'Report',
    cn: '',
  },
  'sql.title.ssr': {
    ko: 'SSR 정보',
    ja: 'SSR情報',
    en: 'SSR Infomation',
    cn: '',
  },
  'sql.cua.func': {
    ko: 'Internal Command',
    ja: '内部コマンド',
    en: 'Internal Command',
    cn: '',
  },
  'sql.title.sql.cmd.list': {
    ko: 'SQL Command 목록',
    ja: 'SQLコマンドリスト',
    en: 'SQL Command List',
    cn: '',
  },
  'sql.tcode': {
    ko: 'T-Code',
    ja: 'Tコード',
    en: 'T-Code',
    cn: '',
  },
  'sql.sql.time': {
    ko: 'SQL Time',
    ja: 'SQL時間',
    en: 'SQL Time',
    cn: '',
  },
  'sql.title.sqlList': {
    ko: 'SQL 목록',
    ja: 'SQLリスト',
    en: 'SQL List',
    cn: '',
  },
  'sql.title.sql.detail': {
    ko: '상세 내역',
    ja: '詳細',
    en: 'Details',
    cn: '',
  },
  'sql.line.number': {
    ko: 'Line Number',
    ja: '行番号',
    en: 'Line Number',
    cn: '',
  },
  'sql.sessionSerial': {
    ko: '세션 일련번호',
    ja: 'セッションのシリアル番号',
    en: 'Session Serial',
    cn: '',
  },
  'sql.userId': {
    ko: '사용자 ID.',
    ja: 'ユーザーID',
    en: 'User ID.',
    cn: '',
  },
  'sql.begin': {
    ko: '시작 일시',
    ja: '開始日時',
    en: 'Begin DateTime',
    cn: '',
  },
  'sql.title.bind': {
    ko: '바인드 변수 목록',
    ja: 'バインド変数のリスト',
    en: 'Bind variable list',
    cn: '',
  },
  'sql.src.module': {
    ko: 'Source Module',
    ja: 'ソースモジュール',
    en: 'Source Module',
    cn: '',
  },
  'sql.system': {
    ko: '시스템',
    ja: 'システム',
    en: 'System',
    cn: '',
  },
  'sql.app.src': {
    ko: 'Application Source',
    ja: 'アプリのソース',
    en: 'Application Source',
    cn: '',
  },
  'sql.title.oper.list': {
    ko: '오퍼레이션 목록',
    ja: 'オペレーションリスト',
    en: 'Operation List',
    cn: '',
  },
  'sql.oper.duration': {
    ko: '수행 시간 (ms)',
    ja: '実行時間(ms)',
    en: 'Duration (ms)',
    cn: '',
  },
  'sql.end': {
    ko: '종료 일시',
    ja: '終了日時',
    en: 'End DateTime',
    cn: '',
  },
  'sql.oper.name': {
    ko: '오퍼레이션 명',
    ja: 'オペレーション名',
    en: 'Operation Name',
    cn: '',
  },
  'sql.db.time': {
    ko: 'DB Time (ms)',
    ja: 'DB時間(ms)',
    en: 'DB Time (ms)',
    cn: '',
  },
  'sql.param.value': {
    ko: '값',
    ja: '値',
    en: 'Value',
    cn: '',
  },
  'sql.respti': {
    ko: 'R.T. (ms)',
    ja: 'R.T. (ms)',
    en: 'R.T. (ms)',
    cn: '',
  },
};
